import { render, staticRenderFns } from "./TeacherBio.vue?vue&type=template&id=42ffda24&scoped=true&"
import script from "./TeacherBio.vue?vue&type=script&lang=js&"
export * from "./TeacherBio.vue?vue&type=script&lang=js&"
import style0 from "./TeacherBio.vue?vue&type=style&index=0&id=42ffda24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ffda24",
  null
  
)

export default component.exports